import { useState } from "react";
import { NavLink, Link, useLocation } from "react-router-dom";
import { useMarket } from "../lib/api";
import { fmtPct, fmtUsd } from "../lib/format";
import { ConnectButton } from "./Connect";
import { Logo } from "./Logo";

const LINKS = [
  ["/trade", "Trade"],
  ["/earn", "Earn"],
  ["/portfolio", "Portfolio"],
  ["/rewards", "Rewards"],
  ["/docs", "Docs"],
] as const;

export function Nav() {
  const { data: m } = useMarket();
  const [open, setOpen] = useState(false);
  const landing = useLocation().pathname === "/";
  return (
    <header className={`nav ${landing ? "nav-landing" : ""}`}>
      <div className="wrap">
        <Link to="/" aria-label="$STRIKE home" className="nav-home">
          <Logo />
        </Link>
        <nav className={`nav-links ${open ? "open" : ""}`} onClick={() => setOpen(false)}>
          {LINKS.map(([to, label]) => (
            <NavLink key={to} to={to} className={({ isActive }) => (isActive ? "active" : "")}>
              {label}
            </NavLink>
          ))}
        </nav>
        <div className="nav-right">
          {landing ? (
            <Link to="/trade" className="btn btn-primary nav-cta">
              Launch app
            </Link>
          ) : (
            <>
              {m?.launched && (
                <span className="nav-price">
                  <img src="/mark.svg" alt="" width="16" height="16" />
                  <span>{fmtUsd(m.marketCapUsd)}</span>
                  <span className={m.change24hPct >= 0 ? "call" : "put"}>{fmtPct(m.change24hPct)}</span>
                </span>
              )}
              <ConnectButton />
            </>
          )}
          <button className="nav-burger" aria-label="Menu" onClick={() => setOpen((o) => !o)}>
            <svg width="16" height="16" viewBox="0 0 16 16">
              <path d="M2 4h12M2 8h12M2 12h12" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
            </svg>
          </button>
        </div>
      </div>
    </header>
  );
}
